import axios from "axios";
import { APIAddress } from "constants/config";
import Joi from 'joi-browser';

const TARGET = ['student', 'teacher']
export const STATUS = ['unchecked', 'attended', 'absent (with excuse)', 'late', 'absent (without notice)']

export const schema = Joi.object().keys({
  "is_teacher": Joi.string().valid(TARGET).required(),
  "id": Joi.number().integer().required(),
  "check_in_status": Joi.string().valid(STATUS).allow(''),
});

export default function addLessonAttendance(lessonId, lessonInfo) {

  if(!lessonId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing lesson Id (number)')
      })
    })
  }

  let validateResult = Joi.validate(lessonInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }


  let checkInState; 
  let isTeacher = TARGET.indexOf(lessonInfo.is_teacher);
  if(isTeacher === 0){
    if ( lessonInfo.check_in_status == 'unchecked') {
      checkInState=0;
    }else if ( lessonInfo.check_in_status == 'attended' || lessonInfo.check_in_status == 'late' ) {
      checkInState=1;
    }else if(lessonInfo.check_in_status == 'absent (with excuse)') {
      checkInState=2
    }else {
      checkInState=4;
    }
  }else {
    if ( lessonInfo.check_in_status == 'unchecked' || lessonInfo.check_in_status == 'absent (without notice)' ) {
      checkInState=0;
    }else if ( lessonInfo.check_in_status == 'attended' || lessonInfo.check_in_status == 'late' ) {
      checkInState=1;
    }else {
      checkInState=2
    }
  }
  const toServer = {
    ...lessonInfo,
    is_teacher: isTeacher,
    check_in_status: checkInState
  }
  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/g_chc/${lessonId}/`,
    'method': 'POST',
    'data': JSON.stringify(toServer),
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/lesson/addLessonAttendance.js